import CONFIG_KEYS from "../config";
import CustomApiError from "../models/CustomApiError";


export const replaceFileName = (originalName: string, token: string, suffix = "") => {
      const dot = originalName.lastIndexOf(".");
      const ext = dot >= 0 ? originalName.slice(dot) : "";
      const safeToken = (token ?? "").toString().replace(/[^A-Za-z0-9-_]/g, "");
      return `${safeToken}${suffix}${ext}`;
    };

export function generateGuid(): string {
  // Returns a RFC4122 version 4 compliant UUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
      const random = Math.random() * 16 | 0;
      const value = char === 'x' ? random : (random & 0x3 | 0x8);
      return value.toString(16);
  });
}

export const currencySymbol = (currency: string) => {
  if (currency) {
    // Create a NumberFormat instance with currency display option set to 'symbol'
    const currencyFormatter = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'symbol'
    });
    // Format a number with the currency symbol
    return currencyFormatter.formatToParts(1)[0].value;
  }
  else
    return "";
};

export function getErrorMsg(e1: unknown): string {
  let message: string = "";
  if (e1 instanceof Error) {
    message = e1.message;
  } else if (e1 instanceof CustomApiError) {
    message = e1.message;
  } else if (typeof e1 === 'string') {
    message = e1;
  }
  return message;
}

export function checkFileSize(file: File): boolean {
  if (file) {
    if (file.type.startsWith('image/'))
      return (file.size < CONFIG_KEYS.fileSize_imageMaxSizeMB * 1024 * 1024);
    else if (file.type.startsWith('video/'))
      return (file.size < CONFIG_KEYS.fileSize_videoMaxSizeMB * 1024 * 1024);
    else if (file.type === 'application/pdf')
      return (file.size < CONFIG_KEYS.fileSize_DocumentMaxSizeMB * 1024 * 1024);
  }
  return false;
}

const openShareWindow = (shareUrl: string) => {
  if (!shareUrl) return;

  window.open(
    shareUrl,
    "_blank",
    "noopener,noreferrer,width=600,height=400"
  );
};

export const Shareskype = (currentUrl: string, title?: string) => {
  if (!currentUrl) return;

  const text = title ?? "";
  const skypeShareUrl = `https://web.skype.com/share?url=${encodeURIComponent(
    currentUrl
  )}${text ? `&text=${encodeURIComponent(text)}` : ""}`;

  openShareWindow(skypeShareUrl);
};

export const Sharefacebook = (currentUrl: string, title?: string) => {
  if (!currentUrl) return;

  // Facebook sharer — &quote is deprecated; only &u is officially supported
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;

  // Facebook requires the popup NOT to have noopener/noreferrer,
  // and needs specific dimensions to trigger the share dialog
  window.open(
    facebookShareUrl,
    "facebook-share-dialog",
    "width=626,height=436,toolbar=0,menubar=0,location=0,status=1,scrollbars=1,resizable=1"
  );
};

export const Sharelinkedin = (currentUrl: string, title?: string) => {
  if (!currentUrl) return;

  const linkedinShareUrl =
    `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}` +
    (title ? `&title=${encodeURIComponent(title)}` : "");

  openShareWindow(linkedinShareUrl);
};

export const Sharetwitter = (currentUrl: string, title?: string) => {
  if (!currentUrl) return;

  const twitterShareUrl =
    `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}` +
    (title ? `&text=${encodeURIComponent(title)}` : "");

  openShareWindow(twitterShareUrl);
};


export const GetColorBasedOnText = (text: string | null | undefined): string => {
  if (!text) text = "default";
  const hash = text.split('').reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc);
  }, 0);

  const color = '#' + ((hash & 0x00FFFFFF) | 0x44000000).toString(16).toUpperCase().slice(0, 6);
  return color;
};

export const GetIniti= (name: string): string => {
  if (!name) return "";

  const parts = name.trim().split(/\s+/); // split by spaces (handles extra spaces)
  const first = parts[0]?.charAt(0).toUpperCase() ?? "";
  const second = parts[1]?.charAt(0).toUpperCase() ?? "";

  return first + second;
};

export const getDefaultImage = (title: string,size:number) =>
  `https://ui-avatars.com/api/?name=${encodeURIComponent(title)}&background=random&size=${size}`;



// const App = () => {
//   return (
//     <div>
//       <h1>React Toast and SweetAlerts</h1>
//       <Notification title="Notification Title" message="Notification Message" positionClass="toast-bottom-right" />
//       <SweetAlerts title="SweetAlert Title" message="SweetAlert Message" />
//     </div>
//   );
// };



